import React from "react";
import { useParams } from "react-router-dom";

import PageContainer from "../components/shared/PageContainer";

const BackfillDetails: React.FC = () => {
  const { id } = useParams();

  return (
    <PageContainer>
      <h2>Backfill Details</h2>
      <p>Backfill ID: {id}</p>
    </PageContainer>
  );
};

export default BackfillDetails;
